module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_DE.234759f0.txt";